/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetProducts200ResponseItemsInnerInformation } from './GetProducts200ResponseItemsInnerInformation';
import {
    GetProducts200ResponseItemsInnerInformationFromJSON,
    GetProducts200ResponseItemsInnerInformationFromJSONTyped,
    GetProducts200ResponseItemsInnerInformationToJSON,
    GetProducts200ResponseItemsInnerInformationToJSONTyped,
} from './GetProducts200ResponseItemsInnerInformation';
import type { PatchProductsRequestInnerAllOfSchedulesInner } from './PatchProductsRequestInnerAllOfSchedulesInner';
import {
    PatchProductsRequestInnerAllOfSchedulesInnerFromJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerFromJSONTyped,
    PatchProductsRequestInnerAllOfSchedulesInnerToJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerToJSONTyped,
} from './PatchProductsRequestInnerAllOfSchedulesInner';
import type { PatchProductsRequestInnerAllOfAllergensInner } from './PatchProductsRequestInnerAllOfAllergensInner';
import {
    PatchProductsRequestInnerAllOfAllergensInnerFromJSON,
    PatchProductsRequestInnerAllOfAllergensInnerFromJSONTyped,
    PatchProductsRequestInnerAllOfAllergensInnerToJSON,
    PatchProductsRequestInnerAllOfAllergensInnerToJSONTyped,
} from './PatchProductsRequestInnerAllOfAllergensInner';

/**
 * 
 * @export
 * @interface PatchProductsRequestInner
 */
export interface PatchProductsRequestInner {
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInner
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchProductsRequestInner
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchProductsRequestInner
     */
    price?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchProductsRequestInner
     */
    modifierGroups?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchProductsRequestInner
     */
    hasSchedule?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchProductsRequestInner
     */
    controlEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInner
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInner
     */
    imageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInner
     */
    kitchenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInner
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInner
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInner
     */
    course?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductsRequestInner
     */
    taxCategories?: string | null;
    /**
     * 
     * @type {Array<PatchProductsRequestInnerAllOfAllergensInner>}
     * @memberof PatchProductsRequestInner
     */
    allergens?: Array<PatchProductsRequestInnerAllOfAllergensInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchProductsRequestInner
     */
    specifications?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchProductsRequestInner
     */
    additives?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchProductsRequestInner
     */
    isPrepackaged?: boolean | null;
    /**
     * 
     * @type {GetProducts200ResponseItemsInnerInformation}
     * @memberof PatchProductsRequestInner
     */
    information?: GetProducts200ResponseItemsInnerInformation | null;
    /**
     * 
     * @type {Array<PatchProductsRequestInnerAllOfSchedulesInner>}
     * @memberof PatchProductsRequestInner
     */
    schedules?: Array<PatchProductsRequestInnerAllOfSchedulesInner>;
}

/**
 * Check if a given object implements the PatchProductsRequestInner interface.
 */
export function instanceOfPatchProductsRequestInner(value: object): value is PatchProductsRequestInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PatchProductsRequestInnerFromJSON(json: any): PatchProductsRequestInner {
    return PatchProductsRequestInnerFromJSONTyped(json, false);
}

export function PatchProductsRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchProductsRequestInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'price': json['price'] == null ? undefined : json['price'],
        'modifierGroups': json['modifierGroups'] == null ? undefined : json['modifierGroups'],
        'hasSchedule': json['hasSchedule'] == null ? undefined : json['hasSchedule'],
        'controlEnabled': json['controlEnabled'] == null ? undefined : json['controlEnabled'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'kitchenName': json['kitchenName'] == null ? undefined : json['kitchenName'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'color': json['color'] == null ? undefined : json['color'],
        'course': json['course'] == null ? undefined : json['course'],
        'taxCategories': json['taxCategories'] == null ? undefined : json['taxCategories'],
        'allergens': json['allergens'] == null ? undefined : ((json['allergens'] as Array<any>).map(PatchProductsRequestInnerAllOfAllergensInnerFromJSON)),
        'specifications': json['specifications'] == null ? undefined : json['specifications'],
        'additives': json['additives'] == null ? undefined : json['additives'],
        'isPrepackaged': json['isPrepackaged'] == null ? undefined : json['isPrepackaged'],
        'information': json['information'] == null ? undefined : GetProducts200ResponseItemsInnerInformationFromJSON(json['information']),
        'schedules': json['schedules'] == null ? undefined : ((json['schedules'] as Array<any>).map(PatchProductsRequestInnerAllOfSchedulesInnerFromJSON)),
    };
}

export function PatchProductsRequestInnerToJSON(json: any): PatchProductsRequestInner {
    return PatchProductsRequestInnerToJSONTyped(json, false);
}

export function PatchProductsRequestInnerToJSONTyped(value?: PatchProductsRequestInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'price': value['price'],
        'modifierGroups': value['modifierGroups'],
        'hasSchedule': value['hasSchedule'],
        'controlEnabled': value['controlEnabled'],
        'description': value['description'],
        'imageId': value['imageId'],
        'kitchenName': value['kitchenName'],
        'shortName': value['shortName'],
        'color': value['color'],
        'course': value['course'],
        'taxCategories': value['taxCategories'],
        'allergens': value['allergens'] == null ? undefined : ((value['allergens'] as Array<any>).map(PatchProductsRequestInnerAllOfAllergensInnerToJSON)),
        'specifications': value['specifications'],
        'additives': value['additives'],
        'isPrepackaged': value['isPrepackaged'],
        'information': GetProducts200ResponseItemsInnerInformationToJSON(value['information']),
        'schedules': value['schedules'] == null ? undefined : ((value['schedules'] as Array<any>).map(PatchProductsRequestInnerAllOfSchedulesInnerToJSON)),
    };
}

